import React, { useEffect, useState } from "react";
import {
  ButtonBack,
  Container,
  Logo,
  ViewMax,
  ViewRow,
  ViewStats,
  ViewNotificationItem,
} from "./styles";
import logo from "./../../images/logo.png";
import {
  Button,
  Input,
  Spin,
  Modal,
  Tooltip,
  ConfigProvider,
  Pagination,
  DatePicker,
} from "antd";
import api from "../../services/api";
import { toast } from "react-toastify";
import { format, addMinutes } from "date-fns";
import { IoMdArrowBack, IoMdHelpCircle } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { MdClose } from "react-icons/md";

const { TextArea } = Input;

export default function PartnerNotifications() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [loadingNotifications, setLoadingNotifications] = useState(false);
  const [loadingCreateNotification, setLoadingCreateNotification] =
    useState(false);
  const [token, setToken] = useState("");
  const [partner, setPartner] = useState({});
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [minutesDiff, setMinutesDiff] = useState(0);
  const [isWithinRange, setIsWithinRange] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [newNotification, setNewNotification] = useState({
    title: "",
    message: "",
    url: "",
    send_at: null,
  });

  useEffect(() => {
    getData();
  }, [page]);

  async function getData() {
    setLoading(true);
    const token = await localStorage.getItem("@partner:token");
    if (token) {
      setToken(token);
      // Get partner info for stats
      await api
        .get(`/partner/auth`, {
          headers: {
            authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          setPartner(response.data);
        })
        .catch(() => {
          localStorage.removeItem("@partner:token");
          navigate("/user/parceiro");
        });

      // Get notifications
      setLoadingNotifications(true);
      api
        .get("/notifications", {
          params: {
            page: page,
          },
          headers: {
            authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          setNotifications(response.data.notifications);
          setMinutesDiff(response.data.minutesDiff);
          setIsWithinRange(response.data.isWithinRange);
          setTotal(response.data.total);
        })
        .catch(() => {
          toast.error("Erro ao carregar notificações");
        })
        .finally(() => {
          setLoadingNotifications(false);
        });
    } else {
      navigate("/user/parceiro");
    }
    setLoading(false);
  }

  async function getNotifications() {
    const token = await localStorage.getItem("@partner:token");
    if (token) {
      setLoadingNotifications(true);
      api
        .get("/notifications", {
          params: {
            page: page,
          },
          headers: {
            authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          setNotifications(response.data.notifications);
          setMinutesDiff(response.data.minutesDiff);
          setIsWithinRange(response.data.isWithinRange);
          setTotal(response.data.total);
        })
        .catch(() => {
          toast.error("Erro ao carregar notificações");
        })
        .finally(() => {
          setLoadingNotifications(false);
        });
    }
  }

  async function createNotification() {
    if (!newNotification.title || !newNotification.message) {
      toast.warn("Preencha todos os campos");
      return;
    }

    setLoadingCreateNotification(true);
    api
      .post("/notifications", newNotification, {
        headers: {
          authorization: `Bearer ${token}`,
        },
      })
      .then(() => {
        toast.success("Solicitação de disparo enviada com sucesso!");
        setIsModalVisible(false);
        setNewNotification({ title: "", message: "", url: "", send_at: null });
        getNotifications();
      })
      .catch(({ response }) => {
        if (response?.data?.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro ao enviar disparo. Tente novamente");
        }
      })
      .finally(() => {
        setLoadingCreateNotification(false);
      });
  }

  return (
    <Container>
      {loading ? (
        <Spin style={{ marginTop: 120 }} size="large" />
      ) : (
        <ViewMax>
          <ViewRow>
            <ButtonBack onClick={() => navigate("/user/parceiro")}>
              <IoMdArrowBack color="#363636" size={25} />
            </ButtonBack>
            <Logo
              src={logo}
              style={{ height: 35, margin: 0, objectFit: "contain" }}
            />
          </ViewRow>

          <h1 style={{ marginTop: 20 }}>Disparos de Notificação</h1>
          <ViewStats>
            <div>
              <p
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 5,
                }}
              >
                Por Semana
                <Tooltip
                  title={`Toda semana aos domingos você receberá mais ${partner.sends_week || 0} disparos.`}
                >
                  <IoMdHelpCircle size={18} color="#fff" />
                </Tooltip>
              </p>
              <span>{partner.sends_week || 0}</span>
            </div>
            <div>
              <p>Disponíveis</p>
              <span>{partner.number_sends || 0}</span>
            </div>
            <div>
              <p>Intervalo</p>
              <span>{partner.interval_send || 0} hrs</span>
            </div>
          </ViewStats>

          <p
            style={{
              textAlign: "center",
              marginBottom: 20,
              fontWeight: "bold",
              fontSize: 14,
              color: isWithinRange ? "#ff4d4f" : "#20D072",
            }}
          >
            {isWithinRange
              ? `Próximo disparo disponível em ${format(
                  addMinutes(new Date(), minutesDiff || 0),
                  "dd/MM 'às' HH:mm",
                )}`
              : "Disparo disponível"}
          </p>

          <Button
            type="primary"
            style={{
              width: "95%",
              height: 45,
              marginBottom: 30,
              borderRadius: 8,
              fontWeight: "bold",
              fontSize: 16,
              backgroundColor: "#20D072",
              borderColor: "#20D072",
            }}
            onClick={() => setIsModalVisible(true)}
          >
            NOVO DISPARO
          </Button>

          {loadingNotifications ? (
            <Spin style={{ margin: "20px 0" }} size="small" />
          ) : (
            <>
              <p style={{ marginBottom: 15, fontWeight: "bold", fontSize: 16 }}>
                Histórico de Disparos ({total})
              </p>
              {notifications.length > 0 ? (
                notifications.map((item) => (
                  <ViewNotificationItem key={item.id}>
                    <ViewRow style={{ width: "100%", marginBottom: 5 }}>
                      <h3>{item.title}</h3>
                      <span
                        className={`status ${
                          item.status === "aprovado"
                            ? "aprovado"
                            : item.status === "reprovado"
                              ? "reprovado"
                              : "pendente"
                        }`}
                      >
                        {item.status === "aprovado"
                          ? "Aprovado"
                          : item.status === "reprovado"
                            ? "Reprovado"
                            : "Pendente"}
                      </span>
                    </ViewRow>
                    <p>{item.message}</p>
                    {item.url && (
                      <p
                        style={{
                          fontSize: 12,
                          color: "#20D072",
                          marginBottom: 5,
                          cursor: "pointer",
                          textDecoration: "underline",
                        }}
                        onClick={() => window.open(item.url, "_blank")}
                      >
                        URL: {item.url}
                      </p>
                    )}
                    <span className="date">
                      Criado em{" "}
                      {format(new Date(item.create_at), "dd/MM/yyyy HH:mm")}
                    </span>
                    <br />
                    <span className="date">
                      Disparo programado para{" "}
                      {format(new Date(item.send_at), "dd/MM/yyyy HH:mm")}
                    </span>
                  </ViewNotificationItem>
                ))
              ) : (
                <p style={{ textAlign: "center", marginTop: 20, opacity: 0.6 }}>
                  Nenhum disparo realizado até o momento.
                </p>
              )}
            </>
          )}

          <Modal
            title={
              <span style={{ color: "#fff", fontFamily: "Montserrat-Bold" }}>
                Novo Disparo de Notificação
              </span>
            }
            open={isModalVisible}
            onCancel={() => setIsModalVisible(false)}
            centered
            closeIcon={<MdClose color="#FFF" size={22} />}
            styles={{
              content: { backgroundColor: "#282828", color: "#fff" },
              header: { backgroundColor: "#282828", color: "#fff" },
              body: { backgroundColor: "#282828" },
              mask: { backdropFilter: "blur(4px)" },
            }}
            footer={[
              <Button
                key="back"
                onClick={() => setIsModalVisible(false)}
                style={{
                  backgroundColor: "transparent",
                  color: "#fff",
                  borderColor: "#666",
                }}
              >
                CANCELAR
              </Button>,
              <Button
                key="submit"
                type="primary"
                loading={loadingCreateNotification}
                onClick={createNotification}
                style={{ backgroundColor: "#20D072", borderColor: "#20D072" }}
              >
                ENVIAR NOTIFICAÇAO
              </Button>,
            ]}
          >
            <div style={{ padding: "10px 0" }}>
              <p style={{ color: "#fff", marginBottom: 5, fontSize: 14 }}>
                Título
              </p>
              <Input
                placeholder="Título da notificação"
                value={newNotification.title}
                style={{
                  backgroundColor: "#363636",
                  color: "#fff",
                  borderColor: "#444",
                }}
                onChange={(e) =>
                  setNewNotification({
                    ...newNotification,
                    title: e.target.value,
                  })
                }
              />
              <p
                style={{
                  color: "#fff",
                  marginBottom: 5,
                  marginTop: 15,
                  fontSize: 14,
                }}
              >
                Texto da Mensagem
              </p>
              <TextArea
                rows={4}
                placeholder="Digite o conteúdo da notificação..."
                style={{
                  backgroundColor: "#363636",
                  color: "#fff",
                  borderColor: "#444",
                }}
                value={newNotification.message}
                onChange={(e) =>
                  setNewNotification({
                    ...newNotification,
                    message: e.target.value,
                  })
                }
              />
              <p
                style={{
                  color: "#fff",
                  marginBottom: 5,
                  marginTop: 15,
                  fontSize: 14,
                }}
              >
                URL (Opcional)
              </p>
              <Input
                placeholder="https://..."
                value={newNotification.url}
                style={{
                  backgroundColor: "#363636",
                  color: "#fff",
                  borderColor: "#444",
                }}
                onChange={(e) =>
                  setNewNotification({
                    ...newNotification,
                    url: e.target.value,
                  })
                }
              />
              <p
                style={{
                  color: "#fff",
                  marginBottom: 5,
                  marginTop: 15,
                  fontSize: 14,
                }}
              >
                Data e Hora do Disparo (Caso não preencha, será imediato)
              </p>
              <DatePicker
                showTime
                format="DD/MM/YYYY HH:mm"
                style={{
                  width: "100%",
                  height: 40,
                }}
                placeholder="Selecione data e hora"
                value={newNotification.send_at}
                onChange={(value) =>
                  setNewNotification({
                    ...newNotification,
                    send_at: value,
                  })
                }
              />
            </div>
          </Modal>
        </ViewMax>
      )}
      {total > 30 && (
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: "#008037",
              colorText: "#fff",
              colorBgContainer: "#363636",
            },
            components: {
              Pagination: {
                itemActiveBg: "#363636",
                itemActiveColor: "#fff",
                itemLinkColor: "#fff",
                itemLinkHoverColor: "#fff",
                itemLinkBg: "transparent",
                itemLinkHoverBg: "#1a1a1a",
                itemHoverBg: "#1a1a1a",
                itemHoverColor: "#fff",
              },
            },
          }}
        >
          <Pagination
            style={{
              margin: "25px 0",
              alignSelf: "center",
            }}
            showSizeChanger={false}
            current={page + 1}
            pageSize={30}
            onChange={(page) => {
              setPage(page - 1);
            }}
            total={total}
          />
        </ConfigProvider>
      )}
    </Container>
  );
}
